import { generateTitle } from 'utils/charts/common';
import {
    noResultsText,
    CONCENTRATED_EO_TRADES,
    CONCENTRATED_EO_TRADES_SCORE,
    NON_OUTLIER_RM,
    OUTLIER_RM
} from 'utils/charts/constants';
import GreyCircle from 'assets/images/grey-circle.svg';
import RedCircle from 'assets/images/red-circle.svg';
import GreyRMIcon from 'assets/images/grey-rm-icon.svg';

const nonOutlierRM = {
    image: {
        type: 'image',
        style: {
            image: GreyCircle,
            width: 12,
            height: 12,
            opacity: 0.4
        },
        cursor: 'default',
        bottom: 10,
        left: '30%'
    },
    text: {
        type: 'text',
        style: {
            text: NON_OUTLIER_RM,
            font: '10px "Outfit" 400',
            fill: '#929292'
        },
        cursor: 'default',
        bottom: 10,
        left: '35%'
    }
};

const outlierRM = {
    image: {
        type: 'image',
        style: {
            image: RedCircle,
            width: 12,
            height: 12
        },
        cursor: 'default',
        bottom: 10,
        left: '55%'
    },
    text: {
        type: 'text',
        style: {
            text: OUTLIER_RM,
            font: '10px "Outfit" 400',
            fill: '#929292'
        },
        cursor: 'default',
        bottom: 10,
        left: '60%'
    }
};

const rmSymbolAndTextGraphic = {
    image: {
        type: 'image',
        style: {
            image: GreyRMIcon,
            width: 12,
            height: 12
        },
        cursor: 'default',
        top: 5,
        right: 45
    },
    text: {
        type: 'text',
        style: {
            text: 'RM',
            font: '10px "Outfit" 400',
            fill: '#929292'
        },
        cursor: 'default',
        top: 5,
        right: 20
    }
};

export const scenarioFourNoResultOutlierChartOptions = () => {
    return {
        title: generateTitle(CONCENTRATED_EO_TRADES),
        xAxis: {
            type: 'category',
            axisTick: { show: false },
            axisLine: { show: false },
            axisLabel: { show: false }
        },
        yAxis: {
            type: 'value',
            name: CONCENTRATED_EO_TRADES_SCORE,
            nameLocation: 'center',
            nameGap: 65,
            nameTextStyle: {
                padding: [20, 0, 0, 0],
                color: '#8DA8B3',
                fontWeight: 'bold'
            }
        },
        grid: {
            width: '320px',
            left: '80px'
        },
        graphic: [
            nonOutlierRM.image,
            nonOutlierRM.text,
            outlierRM.image,
            outlierRM.text,
            rmSymbolAndTextGraphic.image,
            rmSymbolAndTextGraphic.text,
            noResultsText
        ]
    };
};
